export default __webpack_public_path__ + "static/media/badge-ch-m.cc01aa1b.png";